import styled from "styled-components";

export const SeoPageWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  padding-bottom: 2rem;
  margin-top: 2rem;
`;
export const PageLeft = styled.div`
  width: 285px;
  flex-shrink: 0;
  overflow: hidden;
  .appendTop16 {
    margin-top: 1.6rem;
  }
`;
export const PageRight = styled.div(
  props => `
    width: 892px;
    flex-shrink: 0;
    position: relative;
    margin-top: ${props.isRoute ? '0' : '-4rem'}
`);

export const SeoWrapper = styled.div`
  background-color: #eef4fd;
`;

export const PageHeader = styled.div`
    max-width: 1200px;
    margin: 2rem auto 6rem;
`;
